import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { StorageService } from '../services/storage.service';
import { HelperService } from '../services';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MiniEnvConfigResolver implements Resolve<any> {

  constructor(
    private http: HttpClient,
    private storageService: StorageService,
    private helperService: HelperService
  ) {}

  resolve(): Observable<any> {
    const path = `/assets/${environment.TENANT}/mini-env/${environment.miniEnvFile}`;
    const current = window.location.hostname;
    // const current = 'kapitalhw-demo.unifywellbenefits.com';

    if (localStorage.getItem('miniEnvConfigForDomain') === 'true') {
      return of(null);
    }

    localStorage.setItem('miniEnvConfigForDomain', 'true');

    return this.http.get<any>(path).pipe(
      tap((configJson) => {
        this.helperService.minienvConditions(configJson, current);
      }),
      catchError((err) => {
        console.error('Failed to load mini-env config', err);
        return of(null);
      })
    );
  }
}